module.exports = __webpack_public_path__ + "img/image (42).6f097e9b.jpg";